import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'procure-show-slider',
  templateUrl: './show-slider.component.html',
  styleUrl: './show-slider.component.scss',
  imports: [
    MatSlider,
    MatSliderThumb,
    ReactiveFormsModule,
    MatIcon,
    MatTooltip,
    MatLabel,
  ],
})
export class ShowSlider {
  readonly label = input.required<string>();
  readonly value = input.required<number>();
  readonly hint = input<string>('');
  readonly min = input(0);
  readonly max = input(100);
  readonly step = input(1);

  readonly displayWith = input<(value: number) => string>(
    (value) => `${value}`,
  );
}
